export default {
    dictionary: {
        zh_CN: {
            messages: {
                email: () => '请输入正确的邮箱格式',
                required: (field) => "必填项，请输入",
                numeric: (field) => "请输入整数",
                decimal: (field, args) => {
                    if (args != null && args[0] != null) {
                        return "请输入数字，小数位不超过" + args[0] + "位"
                    }
                    return "请输入数字";
                },
                max: (field, args) => "长度不能超过" + args[0],
                numPat: (field, args) => "请输入数字,总位数不超过" + args[0] + ",小数位不超过" + args[1] + "位",
                isDate: (field, args) => "日期必须符合yyyy-MM-dd格式",
                chinaMobile: (field, args) => "请输入正确的手机号码",
                nature: () => "请输入自然数",
                integer: () => "请输入整数",
                idNum: () => "请输入合法的身份证号码",
                dateMax: (field) => "日期必须大于等于今天！",
                length: (field, args) => "输入长度超过范围！",
            }
        }
    },
    idNum: {
        getMessage: field => "请输入合法的身份证号码",
        validate(value) {　　　　
            if ((/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/.test(value))) {　　　　　　 return true;　　　　 }
            return false;
        }
    },
    integer: {
        getMessage: field => "请输入整数",
        validate(value) {　　　　
            if ((/(^(\+|-)?\d+$)/.test(value))) {　　　　　　 return true;　　　　 }
            return false;
        }
    },
    nature: {
        getMessage: field => "请输入自然数",
        validate(value) {　　　　
            if ((/(^[0-9]+$)/.test(value))) {　　　　　　 return true;　　　　 }
            return false;
        }
    },
    chinaMobile: {
        getMessage: field => "请输入正确的手机号码",
        validate(value, args) {
            var regu = /(^[1][0-9]{10}$)|(^0[1][0-9]{10}$)/;
            var re = new RegExp(regu);
            if (re.test(value)) {
                return true;
            }
            return false;
        }
    },
    numPat: {
        getMessage: (field, args) => "请输入数字,总位数不超过" + args[0] + ",小数位不超过" + args[1] + "位",
        validate(value, args) {
            const max = parseInt(args[0]);
            const digit = parseInt(args[1]);
            let valueStr = "" + value;
            if (!isNaN(value)) {
                if (valueStr.indexOf(".") > -1) {
                    if (value.split(".")[1] == null) {
                        return false;
                    } else if (valueStr.length <= (max + 1) && value.split(".")[1].length <= digit) {
                        return true;
                    }
                    return false;
                } else {
                    if (valueStr.length <= max) {
                        return true;
                    }
                    return false;
                }
            } else
                return false;
        }
    },
    isDate: {
        getMessage: (field, args) => "日期必须符合yyyy-MM-dd格式" + args,
        validate(value, args) {
            let dateStr = "";
            //可能传过来
            if (value.length < 10 || value[4] != "-" || value[7] != "-") {
                return false;
            }
            dateStr = new Date("" + value);
            if (isNaN(dateStr.getDate())) {
                return false;
            } else if (!/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/.test(value)) {
                return false;
            }
            const year = value.split("-")[0];
            const month = value.split("-")[1];
            const date = value.split("-")[2];
            const big_month = ["01", "03", "05", "07", "08", "10", "12"];
            const small_month = ["04", "06", "09", "11"];
            //被4整除但不能被100整除，或能被400整除的年份即为闰

            if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) {
                if (month == 2 && date > 29)
                    return false;
            } else {
                if (month == 2 && date > 28)
                    return false;
                let big_include = false;
                for (let i in big_month) {
                    if (big_month[i] == month) {
                        big_include = true;
                        break;
                    }
                }
                let small_include = false;
                for (let i in small_month) {
                    if (small_month[i] == month) {
                        small_include = true;
                        break;
                    }
                }
                if (month == 2 && date > 29) {
                    return false;
                } else if (big_include && parseInt(date) > 31) { // big_month.includes(month)
                    return false;
                } else if (small_include && parseInt(date) > 30) { //small_month.includes(month)
                    return false;
                }
            }
            return true;
        }
    },
    dateMax:{
        getMessage: field => "日期必须大于等于今天！",
        validate(value) {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            date = (year + "-" + (month >= 10 ? month : "0" + month) + "-" + (day >= 10 ? day : "0" + day));
            if((new Date(value.replace(/-/g,"\/"))) >= (new Date(date.replace(/-/g,"\/")))){
                return true;
            }
            return false;
        }
    },
    length:{
        getMessage: (field, args) => "输入长度超过范围！",
        validate(value, args) {
            //如果是联系电话或是身份证号等多数字的特殊的字段则长度大一点，其他字段都是中文的则限制一半
            if(args[1] != undefined && args[1] == 0){
                if((args[0]-10) >= value.length){
                    return true;
                }else{
                    return false;
                }
            }else{
                if(args[0]/2 >= value.length){
                    return true;
                }else{
                    return false;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/tool/myValidate.js